export default __webpack_public_path__ + "static/media/free3flare.a1b1292c.svg";